module.exports = __webpack_public_path__ + "static/media/lines.26d08537.svg";